import React, { Component } from "react"
import { withStyles } from "@material-ui/core"

import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"
import * as constants from "../constants"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ABNPriceEnvRisk extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  ABNPriceEnvRiskState: this.props.ABNPriceEnvRisk,
                  selectedEnv: {
                        value: this.props.ABNPriceEnvRisk.ABN_price_env_risk_env_risk_id,
                        label: this.props.ABNPriceEnvRisk.ABN_env_risk_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
            }
      }
      componentDidMount() {
            this.getoptionEnvRisk()
      }

      getoptionEnvRisk = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].ABN_env_risk_id, label: arr.data[k].ABN_env_risk_name })
                              }
                              self.setState({ optionEnvRisk: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_env_risk")
            xhttp.open("POST", `${constants.BASE_URL}/ABN`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedEnv) => {
            var temparray = this.state.ABNPriceEnvRiskState
            temparray.ABN_price_env_risk_env_risk_id = selectedEnv.value
            this.setState({ selectedEnv: selectedEnv, ABNPriceEnvRiskState: temparray })
      }

      handleChangeConditionsPercent = (event) => {
            var temparray = this.state.ABNPriceEnvRiskState
            temparray.ABN_price_env_risk_rate = event
            this.setState({ ABNPriceEnvRiskState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { ABNPriceEnvRiskState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_env")
            fd.append("ABN_price_env_risk_id", ABNPriceEnvRiskState.ABN_price_env_risk_id)
            fd.append("ABN_price_env_risk_rate", ABNPriceEnvRiskState.ABN_price_env_risk_rate)

            xhttp.open("POST", `${constants.BASE_URL}/ABN`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { ABNPriceEnvRiskState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_env")
            fd.append("ABN_price_env_risk_id", ABNPriceEnvRiskState.ABN_price_env_risk_id)

            xhttp.open("POST", `${constants.BASE_URL}/ABN`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { optionEnvRisk, snackMode, snackstr, showSnack, visible, selectedEnv, ABNPriceEnvRiskState } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={5}>
                                    <div>
                                          <label className="on"> درجه خطر مورد بیمه</label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"درجه خطر مورد بیمه"}
                                                value={selectedEnv}
                                                onChange={this.handleInstalmentMode}
                                                options={optionEnvRisk}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                          type="percent"
                                          placeholder="درصد نرخ انتخابی"
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={ABNPriceEnvRiskState.ABN_price_env_risk_rate}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ABNPriceEnvRisk)
